export const incompleteBwatScoreValues = [undefined, null, "", -1];
